import React, { useState } from "react";
import api from "../api";
import { toast } from "react-toastify";

const RegisterCoordinatorPage = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleCancel = () => {
    setName("");
    setEmail("");
    setPhone("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    const payload = { name, email, phone };

    try {
      // Ensure this endpoint matches your Controller mapping
      const response = await api.post("/vres/users/register-coordinator", payload);
      
      toast.success(`Coordinator "${response.data.name || name}" registered successfully!`);
      handleCancel();
      
    } catch (err) {
      console.error("Registration failed", err);
      
      // Handle the 403 explicitly in UI if needed
      if (err.response && err.response.status === 403) {
          toast.error("Permission Denied: Only Admins can register coordinators.");
      } else {
          const errorMessage = err.response?.data?.message || err.message || "Failed to register coordinator.";
          toast.error(errorMessage);
      }
    } finally {
      setIsLoading(false);
    }
  };

  // --- STYLES INJECTION ---
  const PageStyleBlock = () => (
    <style>{`
      .rc-input:focus {
          border-color: #20c997 !important;
          box-shadow: 0 0 0 3px rgba(32, 201, 151, 0.1) !important;
          outline: none;
      }
      .rc-btn:hover:not(:disabled) { opacity: 0.9; }
      .rc-btn:disabled { opacity: 0.6; cursor: not-allowed; }
    `}</style>
  );

  return (
    <div style={styles.formWrapper}>
      <PageStyleBlock />
      
      <div style={styles.formCard}>
        <h2 style={styles.formTitle}>Register Project Coordinator</h2>

        <form onSubmit={handleSubmit}>
          <div style={styles.formGroup}>
            <label htmlFor="name" style={styles.formLabel}>Name</label>
            <input
              type="text"
              id="name"
              className="rc-input"
              style={styles.formControl}
              placeholder="Enter full name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
            />
          </div>

          <div style={styles.formGroup}>
            <label htmlFor="email" style={styles.formLabel}>Email (User ID)</label>
            <input
              type="email"
              id="email"
              className="rc-input"
              style={styles.formControl}
              placeholder="Enter email address"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>

          <div style={styles.formGroup}>
            <label htmlFor="phone" style={styles.formLabel}>Phone</label>
            <input
              type="tel"
              id="phone"
              className="rc-input"
              style={styles.formControl}
              placeholder="Enter phone number"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              required
            />
          </div>

          <div style={styles.formGroup}>
            <label htmlFor="role" style={styles.formLabel}>Role</label>
            <input
              type="text"
              id="role"
              className="rc-input"
              style={{ ...styles.formControl, ...styles.readOnly }}
              value="Project Coordinator"
              readOnly
            />
          </div>

          <div style={styles.btnGroup}>
            <button
              type="button"
              onClick={handleCancel}
              className="rc-btn"
              style={{ ...styles.btn, ...styles.btnSecondary }}
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={isLoading}
              className="rc-btn"
              style={{ ...styles.btn, ...styles.btnPrimary }}
            >
              {isLoading ? "Submitting..." : "Submit"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

const styles = {
  formWrapper: {
    padding: '20px',
    paddingTop: '60px', 
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center', 
    width: '100%',
    minHeight: 'calc(100vh - 70px)', 
    boxSizing: 'border-box',
    fontFamily: "'Segoe UI', Roboto, sans-serif",
    backgroundColor: '#f0fdf9', 
  },
  formCard: {
    background: 'white',
    width: '100%',
    maxWidth: '450px',
    padding: '30px', 
    borderRadius: '12px',
    boxShadow: '0 10px 30px rgba(0,0,0,0.08)',
    borderTop: '5px solid #20c997', 
    margin: '0 auto',
  },
  formTitle: {
    textAlign: 'center',
    marginBottom: '20px',
    fontSize: '1.3rem', 
    color: '#007bff', 
    fontWeight: '700',
    marginTop: 0,
  },
  formGroup: {
    marginBottom: '15px', 
  },
  formLabel: {
    display: 'block',
    marginBottom: '5px',
    fontWeight: '600',
    color: '#2d3436', 
    fontSize: '0.85rem', 
  },
  formControl: {
    width: '100%',
    padding: '10px 12px', 
    border: '1px solid #dcdcdc',
    borderRadius: '6px',
    fontSize: '0.9rem',
    transition: 'all 0.3s',
    outline: 'none',
    boxSizing: 'border-box',
    color: '#2d3436', 
  },
  readOnly: {
    backgroundColor: '#e9ecef',
    color: '#6c757d',
    cursor: 'not-allowed',
    borderColor: '#e1e4e8',
  },
  btnGroup: {
    display: 'flex',
    gap: '15px',
    marginTop: '25px', 
    justifyContent: 'center', 
  },
  btn: {
    padding: '8px 24px', 
    borderRadius: '6px',
    fontSize: '0.9rem',
    fontWeight: '600',
    cursor: 'pointer',
    border: 'none',
    minWidth: '100px',
    transition: 'opacity 0.2s',
  },
  btnPrimary: {
    backgroundColor: '#007bff', 
    color: 'white',
  },
  btnSecondary: {
    backgroundColor: '#6c757d', 
    color: 'white',
  },
};

export default RegisterCoordinatorPage;